import React from 'react'
import ViewInvoiceSection from '../../../component/billing-payments/invoice/ViewInvoiceSection'

function ViewInvoice() {
  return (
    <div  className='page-body'>
       <ViewInvoiceSection/>
      
    </div>
  )
}

export default ViewInvoice
